export default function FaultsViewRowDisplayDirective() {

  'ngInject';

  return {
    template: require('./view.html'),
    transclude: true,
    restrict: 'E',
    scope: {},
    controller: ViewFaultFormController,
    controllerAs: 'vm',
    bindToController: {
      fault: '=',
      isEditMode: '=',
      deleteFault: '&',
      enableEditMode: '&'
    }
  };

  function ViewFaultFormController() {
    var vm = this;
  }
}